<template>
  <div v-if="!item.hidden&&item.children" class="menu-wrapper">

    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item v-if="onlyOneChild.meta" :icon="onlyOneChild.meta.icon||item.meta.icon" :path="onlyOneChild.path" :title="generateTitle(onlyOneChild.meta.title)" />
          <el-badge v-if="!onlyOneChild.noShowingChildren && getMenuUnreadCount(onlyOneChild) > 0" :value="getMenuUnreadCount(onlyOneChild)" :max="99" class="menu-badge" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="submenu" :index="resolvePath(item.path)" class="submenu-wrapper">
      <template slot="title">
        <div class="submenu-title-wrapper" @click="handleMenuClick(item)">
          <item v-if="item.meta" :icon="item.meta.icon" :path="item.path" :title="generateTitle(item.meta.title)" />
          <el-badge v-if="hasUnreadChildren(item) && getMenuUnreadCount(item) > 0" :value="getMenuUnreadCount(item)" :max="99" class="menu-badge" />
        </div>
      </template>

      <div v-for="(child, index) in item.children" :key="index">
        <template v-if="!child.hidden">
          <sidebar-item v-if="child.children&&child.children.length>0" :is-nest="true" :item="child" :key="child.path" :base-path="resolvePath(child.path)" :class="'nest-menu ' + child.hidden" />
          <app-link v-else :to="resolvePath(child.path)" :key="child.name">
            <el-menu-item :index="resolvePath(child.path)" class="menu-item-wrapper">
              <item v-if="child.meta" :icon="child.meta.icon" :path="child.path" :title="generateTitle(child.meta.title)" />
              <el-badge v-if="getMenuUnreadCount(child) > 0" :value="getMenuUnreadCount(child)" :max="99" class="menu-badge" />
            </el-menu-item>
          </app-link>
        </template>
      </div>
    </el-submenu>

  </div>
</template>

<script>
import path from 'path'
import { mapGetters } from 'vuex'
import { generateTitle } from '@/utils/i18n'
import { isExternal } from '@/utils'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      onlyOneChild: null
    }
  },
  computed: {
    ...mapGetters('noticeBoard', [
      'promotionUnread',
      'meetingUnread',
      'activityUnread',
      'totalUnread',
      'pendingDeviceCount',
      'pendingRectificationCount',
      'pendingConfirmationCount',
      'samplingPendingRectificationCount',
      'samplingPendingConfirmationCount',
      'samplingPendingRectificationCountInside',
      'samplingPendingRectificationCountOutside',
      'samplingPendingConfirmationCountInside',
      'samplingPendingConfirmationCountOutside'
    ])
  },
  methods: {
    handleMenuClick(menuItem) {
      if (menuItem.meta && menuItem.meta.title === '双重预防机制') {
        this.$router.push('/safetyPrevention/welcome')
      }
    },
    hasOneShowingChild(children, parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (this.isExternalLink(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath, routePath)
    },
    isExternalLink(routePath) {
      return isExternal(routePath)
    },
    generateTitle,
    /**
     * 检查菜单项的子菜单是否有未读数
     */
    hasUnreadChildren(menuItem) {
      if (!menuItem || !menuItem.children || menuItem.children.length === 0) {
        return false
      }

      // 检查所有子菜单是否有未读数
      for (const child of menuItem.children) {
        if (!child.hidden) {
          // 如果子菜单有未读数，返回 true
          if (this.getMenuUnreadCount(child) > 0) {
            return true
          }
          // 如果子菜单还有子菜单，递归检查
          if (child.children && child.children.length > 0) {
            if (this.hasUnreadChildren(child)) {
              return true
            }
          }
        }
      }

      return false
    },
    /**
     * 获取菜单项的未读数
     */
    getMenuUnreadCount(menuItem) {
      if (!menuItem) {
        return 0
      }

      // 获取完整路径，避免重名问题
      const fullPath = this.resolvePath(menuItem.path)

      // 风险排查管理菜单 - 显示排查任务整改 + 整改监管的总未读数
      if (fullPath === '/safetyPrevention/riskInspectionMan') {
        return this.pendingRectificationCount + this.pendingConfirmationCount
      }

      // 双重预防机制大菜单 - 显示公告栏 + 风险设备检验 + 风险排查管理 + 风险治理管理的总未读数
      if (fullPath === '/safetyPrevention') {
        return this.totalUnread + this.pendingDeviceCount + this.pendingRectificationCount + this.pendingConfirmationCount + this.samplingPendingRectificationCount + this.samplingPendingConfirmationCount
      }

      // 公告栏菜单 - 显示三个子菜单的总未读数
      if (fullPath === '/safetyPrevention/noticeBoard/noticeBoard') {
        return this.totalUnread
      }

      // 公告查看菜单 - 显示三个子菜单的总未读数
      if (fullPath === '/safetyPrevention/noticeBoard/noticeView/noticeView' || fullPath === '/safetyPrevention/noticeBoard/noticeView') {
        return this.totalUnread
      }

      // 宣传公告
      if (fullPath === '/safetyPrevention/noticeBoard/noticeView/promotion') {
        return this.promotionUnread
      }

      // 会议公告
      if (fullPath === '/safetyPrevention/noticeBoard/noticeView/meeting') {
        return this.meetingUnread
      }

      // 活动公告
      if (fullPath === '/safetyPrevention/noticeBoard/noticeView/activity') {
        return this.activityUnread
      }

      // 风险设备检验菜单 - 显示待执行设备数量
      if (fullPath === '/safetyPrevention/riskDeviceInspection/riskDeviceInspection') {
        return this.pendingDeviceCount
      }

      // 检验执行菜单 - 显示待执行设备数量
      if (fullPath === '/safetyPrevention/riskDeviceInspection/inspectionExecution') {
        return this.pendingDeviceCount
      }

      // 风险排查管理
      if (fullPath === '/safetyPrevention/riskInspectionMan/riskInspectionMan') {
        return this.pendingRectificationCount + this.pendingConfirmationCount
      }

      // 排查任务整改菜单 - 显示整改任务待执行数量
      if (fullPath === '/safetyPrevention/riskInspectionMan/rectificationTask') {
        return this.pendingRectificationCount
      }

      // 整改监管菜单 - 显示整改任务待确认数量
      if (fullPath === '/safetyPrevention/riskInspectionMan/rectificationSupervision') {
        return this.pendingConfirmationCount
      }

      // 风险治理管理 - 抽检任务整改菜单 - 显示抽检整改任务待执行数量
      if (fullPath === '/safetyPrevention/riskGovernanceMan/samplingRectification') {
        return this.samplingPendingRectificationCount
      }

      // 风险治理管理 - 整改监管菜单 - 显示抽检整改任务待确认数量
      if (fullPath === '/safetyPrevention/riskGovernanceMan/samplingSupervision') {
        return this.samplingPendingConfirmationCount
      }

      // 风险治理管理菜单 - 显示抽检整改任务待执行 + 待确认数量
      if (fullPath === '/safetyPrevention/riskGovernanceMan') {
        return this.samplingPendingRectificationCount + this.samplingPendingConfirmationCount
      }

      // 风险治理管理菜单 (alternative path) - 显示抽检整改任务待执行 + 待确认数量
      if (fullPath === '/safetyPrevention/riskGovernanceMan/riskGovernanceMan') {
        return this.samplingPendingRectificationCount + this.samplingPendingConfirmationCount
      }

      return 0
    }
  }
}
</script>

<style scoped>
.menu-badge {
  position: absolute;
  right: 1px;
  top: -10px;
}

.menu-badge >>> .el-badge__content {
  background-color: #f56c6c;
  border-radius: 50%;
  padding: 0;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  display: inline-block;
  color: white;
  font-weight: bold;
  box-shadow: none;
  border: none;
}

.menu-badge >>> .el-badge {
  display: inline-block;
}

.menu-item-wrapper {
  position: relative;
}

.submenu-wrapper {
  position: relative;
}

.submenu-wrapper >>> .el-submenu__title {
  position: relative;
}

.submenu-title-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>
